import React, { useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridRowSelectionModel,
  GridSortModel,
  GridValueFormatterParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import "./styles.scss";
import "./styles.scss";
import TableFilters from "./TableFilters";
import { CheckType } from "../../types/genericType";
import { convertToLocalWithoutUTC } from "../../utils/dateFormat";
import { formatDollar } from "../../utils/utils";

type BulkChecksTableProps = {
  initialLoad: Function;
  data: Array<CheckType>;
  search: string;
  clearSearch: Function;
  // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowSelectionModel: GridRowSelectionModel;
  setRowSelectionModel: Function;
};

const BulkChecksTable = (props: BulkChecksTableProps) => {
  const {
    initialLoad,
    data,
    search,
    onSearchChange,
    clearSearch,
    rowSelectionModel,
    setRowSelectionModel,
  } = props;

  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "number", sort: "asc" },
  ]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };
  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "date",
        headerName: "Check Date",
        minWidth: 120,
        sortable: true,
        valueFormatter: (params: GridValueFormatterParams) =>
          convertToLocalWithoutUTC(params.value).format("MM/DD/YYYY"),
        headerClassName: "header-datagrid",
      },
      {
        field: "number",
        headerName: "Check Number",
        minWidth: 140,
        headerClassName: "header-datagrid",
      },
      {
        field: "payee",
        headerName: "Payee",
        minWidth: 200,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "client",
        headerName: "Client",
        minWidth: 230,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "accountNumber",
        headerName: "Account Number",
        minWidth: 160,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "amount",
        headerName: "Amount",
        minWidth: 130,
        sortable: false,
        headerClassName: "header-datagrid",
        valueGetter: (params: GridValueGetterParams) =>
          `${formatDollar(params.row.amount)}`,
      },
      {
        field: "memo",
        headerName: "Memo",
        minWidth: 300,
        sortable: false,
        headerClassName: "header-datagrid",
      },
    ],
    []
  );

  return (
    <div className="data-table">
      <TableFilters
        onSearchChange={onSearchChange}
        search={search}
        clearSearch={clearSearch}
        initialLoad={initialLoad}
      />
      <DataGrid
        checkboxSelection
        rows={data}
        getRowId={(row) => row.id}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        }}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        pageSizeOptions={[10, 20, 30, 40, 50]}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        rowSelectionModel={rowSelectionModel}
        className="datagrid"
      />
    </div>
  );
};

export default BulkChecksTable;
